<template>
  <v-card>
    <v-card-title>
      Beta Signup Users
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        class="pt-0"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
      <v-btn @click.prevent="csvExport(csvData)" class="ml-3">Export CSV</v-btn>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="accounts"
      :rows-per-page-items="rowsPerPageItems"
      v-bind:pagination.sync="pagination"
      :search="search"
      :loading="isLoading"
      class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <tr @click="goToAccount(props.item.id)">
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.email }}</td>
          <td>
            <a :href="props.item.insta_link" target="_blank">{{
              props.item.instagram
            }}</a>
          </td>
          <td>{{ props.item.promo_code }}</td>
          <td class="text-xs-right">{{ props.item.status }}</td>
          <td class="text-xs-right">{{ props.item.created_at }}</td>
          <td class="text-xs-right col-action">
            <v-btn
              color="success"
              small
              :class="{ 'btn-loading': props.item.is_approving }"
              :disabled="props.item.status !== 'pending'"
              v-on:click.stop.prevent="updateStatus(props.item.id, 'approved')"
              >Approve</v-btn
            >
            <v-btn
              color="error"
              small
              :class="{ 'btn-loading': props.item.is_denying }"
              :disabled="props.item.status !== 'pending'"
              v-on:click.stop.prevent="updateStatus(props.item.id, 'denied')"
              >Deny</v-btn
            >
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  metaInfo() {
    return { title: "Customers" };
  },
  middleware: ["auth", "admin"],
  data: () => ({
    accounts: [],
    headers: [
      { text: "Name", align: "left", value: "name" },
      { text: "Email", align: "left", value: "email" },
      { text: "Instagram", align: "left", value: "instagram" },
      { text: "Beta Access Code", align: "left", value: "promo_code" },
      { text: "Status", align: "right", value: "status" },
      { text: "Contacted At", align: "right", value: "created_at" },
      { text: "Action", align: "right", value: "id" },
    ],
    rowsPerPageItems: [
      10,
      25,
      50,
      { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 },
    ],
    pagination: { sortBy: "created_at", descending: true, rowsPerPage: 10 },
    search: "",
    isLoading: false,
  }),
  mounted() {
    this.fetchAccounts();
  },
  methods: {
    async fetchAccounts() {
      this.isLoading = true;
      axios.get("/api/beta-users").then(
        (response) => {
          let data = response.data;

          this.accounts = data.accounts.map((account) => {
            let instagram = account.instagram ? account.instagram : "";
            while (instagram.charAt(0) === "@") {
              instagram = instagram.substr(1);
            }
            let insta_name = instagram !== "" ? "@" + instagram : "";
            let insta_link = `https://instagram.com/${instagram}`;

            return {
              id: account.id,
              first_name: account.first_name,
              last_name: account.last_name,
              name: account.first_name + " " + account.last_name,
              business_name: account.business_name,
              email: account.email,
              address: account.address,
              insta: account.instagram,
              instagram: insta_name,
              insta_link: insta_link,
              join_reason: account.join_reason,
              resource: account.resource,
              promo_code: account.promo_code,
              status: account.status,
              created_at: account.created_at,
              updated_at: account.updated_at,
              is_approving: false,
              is_denying: false,
            };
          });
          this.isLoading = false;
        },
        (error) => {
          console.error(error.response.data.message);
          this.isLoading = false;
        }
      );
    },
    csvExport(arrData, filename = "Junipurr users") {
      console.log("csv data", arrData);
      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += [
        Object.keys(arrData[0]).join(","),
        ...arrData.map((item) => Object.values(item).join(",")),
      ]
        .join("\n")
        .replace(/(^\[)|(\]$)/gm, "");

      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", filename + ".csv");
      link.click();
    },
    goToAccount(id) {
      this.$router.push({ name: "beta-user", params: { id: id } });
    },
    updateStatus(id, status) {
      if (!this.checkStatusAvailability(id, status)) return;

      this.setLoadingStatus(id, status, true);
      axios
        .post("/api/beta-user/status", {
          id: id,
          status: status,
        })
        .then((response) => {
          this.accounts = this.accounts.map((item) => {
            if (item.id === response.data.account.id) {
              item.status = response.data.account.status;
            }
            return item;
          });
          this.isLoading = false;
          this.setAccountStatus(
            response.data.account.id,
            response.data.account.status
          );
          this.setLoadingStatus(id, status, false);
        })
        .catch((e) => {
          console.log(e);
          this.isLoading = false;
          this.setLoadingStatus(id, status, false);
        });
    },
    checkStatusAvailability(id, status) {
      let isNew = false;
      this.accounts.map((item) => {
        if (item.is_denying || item.is_approving) return;

        if (item.id === id && item.status !== status) {
          isNew = true;
        }
      });
      return isNew;
    },
    setLoadingStatus(id, account_status, loading_status) {
      this.accounts = this.accounts.map((item) => {
        if (item.id === id) {
          if (account_status === "denied") item.is_denying = loading_status;
          if (account_status === "approved") item.is_approving = loading_status;
        }
        return item;
      });
    },
    setAccountStatus(id, status) {
      this.accounts = this.accounts.map((item) => {
        if (item.id === id) {
          item.status = status;
        }
        return item;
      });
    },
    getInfo(value) {
      const result = (value || "")
        .replace(/#/g, "")
        .replace(/, /g, " ")
        .replace(/,/g, " ")
        .replace(/\r?\n|\r/g, " ");

      return result;
    },
  },
  computed: {
    csvData() {
      return this.accounts.map((item) => ({
        "First Name": item.first_name,
        "Last Name": item.last_name,
        Email: item.email,
        Portfolio: this.getInfo(item.insta),
        "Years of Experience": item.years_experience,
        "Studio Name": this.getInfo(item.business_name),
        "Owner?": item.owner,
        "Studio Info": item.stuio_info,
        Address: this.getInfo(item.address),
        Website: item.website,
        "Join Reason": this.getInfo(item.join_reason),
        "Promo Code": item.promo_code,
        Status: item.status,
        "Created At": item.created_at,
        "Updated At": item.updated_at,
      }));
    },
  },
};
</script>

<style lang="scss">
.col-action {
  @media (min-width: 1440px) {
    min-width: 260px;
  }
}

.v-datatable tbody tr {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// resources/js/pages/beta-users.vue